var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sticky-slot',{attrs:{"on-docked":_vm.expandBar}},[_c('div',{staticClass:"controls-container"},[_c('div',{ref:"controls",staticClass:"controls"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }